import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from './base.service';
import { DocumentFile } from '@cl/shared/models/documents/document-file.model';
import { HttpClient } from '@angular/common/http';
import { DocumentFileFilter } from '@cl/shared/models/documents/document-file-filter.model';
import { CommandResult } from '@cl/shared/models';
import { DocumentFileInspection } from '@cl/shared/models/documents/document-file-inspection.model';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DocumentFilesService extends BaseServiceWithFilter<DocumentFile, DocumentFileFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/document-files/');
    }

    async inspectDocumentFile(documentId: number, documentFileId: number): Promise<CommandResult<DocumentFileInspection>> {
        return lastValueFrom(
            this.httpClient.get<CommandResult<DocumentFileInspection>>(`${this.baseApiUrl}${documentId}/${documentFileId}/inspection`),
        );
    }
}
